import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

import { Col, Collapse, ListGroup, ListGroupItem } from "reactstrap";
import { useCommonData } from "../../../../../providers/commonDataProvider";

import CustomCheckbox from "../../../../CustomCheckbox";

const QuoteItemModalEquipmentRental = ({
  selectedEquipmentRentals,
  setSelectedEquipmentRentals,
}) => {
  const [commonDataContext] = useCommonData();
  const [openSection, setOpenSection] = useState();

  const onItemClick = (equipmentRental) => {
    setSelectedEquipmentRentals({
      ...selectedEquipmentRentals,
      [equipmentRental.id]: !selectedEquipmentRentals[equipmentRental.id],
    });
  };

  const onSelectAllClick = () => {
    const allChecked =
      Object.keys(selectedEquipmentRentals).filter(
        (sc) => selectedEquipmentRentals[sc]
      ).length === commonDataContext.quoteItemEquipmentRentals.length;
    const newSelectedEquipmentRentals =
      commonDataContext.quoteItemEquipmentRentals.reduce(
        (p, c) => ({
          ...p,
          [c.id]: !allChecked,
        }),
        {}
      );
    setSelectedEquipmentRentals({
      ...newSelectedEquipmentRentals,
    });
  };

  return commonDataContext.quoteItemEquipmentRentals.length ? (
    <Col className="col-12 mt-3">
      <ListGroup>
        <ListGroupItem
          className={`d-flex justify-content-between align-items-center bg-lighter cursor-pointer border-bottom-${
            openSection ? 0 : 1
          }`}
          onClick={() => setOpenSection(!openSection)}
        >
          <div>
            <span>Equipment Rental</span>
          </div>
          <FontAwesomeIcon
            icon={openSection ? faChevronDown : faChevronUp}
            className="text-muted"
          />
        </ListGroupItem>
        <Collapse isOpen={openSection}>
          {commonDataContext.quoteItemEquipmentRentals.length > 1 && (
            <ListGroupItem
              className="d-flex justify-content-between align-items-center cursor-pointer"
              onClick={() => onSelectAllClick()}
            >
              <div className="flex-shrink-0">Select all</div>
              <CustomCheckbox
                checked={
                  Object.keys(selectedEquipmentRentals).filter(
                    (c) => selectedEquipmentRentals[c]
                  ).length ===
                  commonDataContext.quoteItemEquipmentRentals.length
                }
              />
            </ListGroupItem>
          )}
          {commonDataContext.quoteItemEquipmentRentals.map(
            (equipmentRental) => (
              <ListGroupItem
                key={equipmentRental.id}
                className="d-flex justify-content-between align-items-center cursor-pointer"
                onClick={() => onItemClick(equipmentRental)}
              >
                <div className="flex-shrink-0">{`${equipmentRental.name}`}</div>
                <CustomCheckbox
                  checked={selectedEquipmentRentals[equipmentRental.id]}
                />
              </ListGroupItem>
            )
          )}
        </Collapse>
      </ListGroup>
    </Col>
  ) : null;
};

export default QuoteItemModalEquipmentRental;
